import { Button } from "@solomon-labs/design/components/ui";
import React from "react";

interface TransactionCTAProps {
    /** Whether the wallet is connected */
    connected: boolean;
    /** Whether access control check has completed */
    isChecked: boolean;
    /** Whether the user is allowed (whitelisted / has access) */
    isAllowed: boolean;
    /** Handler to open the wallet connect modal */
    onConnect: () => void;
    /** Handler for the primary action */
    onClick: () => void;
    /** Whether the primary action button should be disabled */
    disabled?: boolean;
    /** Primary action label (e.g. "Stake USDv", "Buy USDv") */
    children: React.ReactNode;
}

/**
 * 3-state CTA button for transaction forms.
 *
 * States:
 * 1. Not connected → "Connect Wallet"
 * 2. Connected but not whitelisted → "Not Whitelisted" (disabled)
 * 3. Connected and allowed → primary action
 *
 * @version 1.0.0
 */
export function TransactionCTA({
    connected,
    isChecked,
    isAllowed,
    onConnect,
    onClick,
    disabled,
    children
}: TransactionCTAProps): React.ReactElement {
    if (!connected) {
        return (
            <Button
                variant="raised"
                size="lg"
                interaction="light-bar"
                fullWidth
                onClick={onConnect}
            >
                Connect Wallet
            </Button>
        );
    }

    if (isChecked && !isAllowed) {
        return (
            <Button
                variant="raised"
                size="lg"
                interaction="light-bar"
                fullWidth
                disabled
            >
                Not Whitelisted
            </Button>
        );
    }

    return (
        <Button
            variant="raised"
            size="lg"
            interaction="light-bar"
            fullWidth
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </Button>
    );
}
